module.exports = __webpack_public_path__ + "img/thank4.5f320341.gif";